'use client';

import React from "react";
import { Building2, Phone, MapPin } from "lucide-react";
import { initialsOf, formatMoney, formatPhone } from "../internals";

export const AccountRow = ({ account, onClick }) => {
  const inactive = account.status === "inactive";
  return (
    <button
      type="button"
      data-testid={`account-row-${account.id}`}
      onClick={onClick}
      className="flex w-full items-center gap-3 rounded-lg border border-zinc-200 bg-white px-3 py-3 text-left transition-colors hover:bg-zinc-50"
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-zinc-900 text-sm font-semibold text-white">
        {initialsOf(account.name)}
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-2">
          <span className="truncate text-sm font-semibold text-zinc-900">{account.name}</span>
          {inactive && (
            <span className="rounded-full bg-zinc-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-zinc-500">
              Inactive
            </span>
          )}
        </span>
        <span className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-0.5 text-xs text-zinc-500">
          {account.contact_person && (
            <span className="inline-flex items-center gap-1"><Building2 size={11} />{account.contact_person}</span>
          )}
          {account.phone && (
            <span className="inline-flex items-center gap-1"><Phone size={11} />{formatPhone(account.phone)}</span>
          )}
          {account.city && (
            <span className="inline-flex items-center gap-1"><MapPin size={11} />{account.city}</span>
          )}
        </span>
      </span>
      {account.value ? (
        <span className="shrink-0 text-sm font-semibold text-zinc-900">{formatMoney(account.value)}</span>
      ) : null}
    </button>
  );
};
